import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createAuth0Client } from '@auth0/auth0-spa-js';
import axios from 'axios';
import { getUrlParam, isDedicatedFlow } from '@white-label-helper/dedicated-flow';
import { getLogoutRedirectUrl } from '@white-label-helper/get-logout-redirect-url';
import { getCookieDomain } from '@white-label-helper/get-cookie-domain';
import { datadogRum } from '@datadog/browser-rum';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';

// Types

// Auth0 localstorage/cookies keys
var CACHE_KEY_PREFIX = '@@auth0spajs@@';
var CACHE_KEY_USER_SUFFIX = '@@user@@';
var COOKIES_KEY_PREFIX = 'auth0';

/**
 * Auth plugin for Nuxt using Auth0.
 *
 * @param {Context} context
 * @param {Inject} inject
 */
export var auth = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref, inject) {
    var app, $config, route, auth;
    return regeneratorRuntime.wrap(function _callee8$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          app = _ref.app, $config = _ref.$config, route = _ref.route;
          auth = {
            isAuthenticated: false,
            user: null,
            auth0Client: null,
            clientId: '',
            domain: '',
            audience: '',
            returnUrl: getLogoutRedirectUrl(),
            // store in the options and get as a cookie or localStorage
            getCurrentFlow: function getCurrentFlow() {
              var path = window.location.pathname;
              var basePath = path.split('/').filter(Boolean)[0];
              var authFlow;
              switch (basePath) {
                case 'lounge-portal':
                  console.log('lounge-portal');
                  authFlow = {};
                  break;
                default:
                  console.log('default-auth');
                  authFlow = {};
              }
              return authFlow;
            },
            /**
             * Initializes the Auth0 client and handles sessions.
             * @async
             * @returns {Promise<void>}
             */
            initAuth: function initAuth() {
              var _this = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _app$$partnerConfig;
                var options, context, _this$auth0Client, _context;
                return regeneratorRuntime.wrap(function _callee$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      // default values
                      _this.clientId = ((_app$$partnerConfig = app['$partnerConfig']) === null || _app$$partnerConfig === void 0 ? void 0 : _app$$partnerConfig.auth0_client_id) || getAppVariable('auth0_client_id');
                      _this.domain = $config === null || $config === void 0 ? void 0 : $config['AUTH0_DOMAIN'];
                      _this.audience = $config === null || $config === void 0 ? void 0 : $config['AUTH0_AUDIENCE'];
                      if (getFeatureFlag('EX_17_LOUNGE_PORTAL')) {
                        _this.getCurrentFlow();
                      }
                      options = {
                        domain: _this.domain,
                        clientId: _this.clientId,
                        cacheLocation: 'localstorage',
                        cookieDomain: getCookieDomain(),
                        authorizationParams: {
                          redirect_uri: "".concat(window.location.origin, "/callback"),
                          // Redirect URL after login
                          audience: _this.audience,
                          // needs partner specific
                          scope: 'openid profile email'
                        },
                        returnUrl: _this.returnUrl
                      };
                      if (isDedicatedFlow(route) || $config['NUXT_ENV_IS_BOOKING_PORTAL']) {
                        // Set dedicated flow Auth0 client values if coming from Admin or Partner extranet's
                        _this.clientId = $config['AUTH0_PARTNER_CLIENT_ID'];
                        _this.domain = $config['AUTH0_PARTNER_DOMAIN'];
                        _this.audience = $config['AUTH0_PARTNER_AUDIENCE'];
                        _this.returnUrl = getUrlParam(route, 'returnUrl') || app['$cookies'].get("".concat(COOKIES_KEY_PREFIX, ".").concat(_this.clientId, ".returnUrl"));
                        options.clientId = _this.clientId;
                        options.domain = _this.domain;
                        options.authorizationParams.audience = _this.audience;
                        options.returnUrl = _this.returnUrl;
                      }

                      // setup auth0 client
                      if (!(_this.clientId && _this.domain && _this.audience)) {
                        _context2.next = 12;
                        break;
                      }
                      _context2.next = 9;
                      return createAuth0Client(options);
                    case 9:
                      _this.auth0Client = _context2.sent;
                      _context2.next = 15;
                      break;
                    case 12:
                      context = {
                        file: 'white-label-plugin > auth.ts > initAuth()',
                        domain: _this.domain || '',
                        clientId: _this.clientId || '',
                        audience: _this.audience || ''
                      };
                      console.error('Datadog error logged - error during initAuth', context);
                      datadogRum.addError(new Error('Error during initAuth: options missing data'), context);
                    case 15:
                      _context2.prev = 15;
                      if (!(window.location.search.includes('code=') && window.location.search.includes('state='))) {
                        _context2.next = 20;
                        break;
                      }
                      _context2.next = 19;
                      return (_this$auth0Client = _this.auth0Client) === null || _this$auth0Client === void 0 ? void 0 : _this$auth0Client.handleRedirectCallback();
                    case 19:
                      // Redirect to homepage from callback page
                      window.location.href = '/';
                    case 20:
                      _context2.next = 27;
                      break;
                    case 22:
                      _context2.prev = 22;
                      _context2.t0 = _context2["catch"](15);
                      _context = {
                        file: 'white-label-plugin > auth.ts > initAuth()',
                        urlParamCode: window.location.search.includes('code='),
                        urlParamState: window.location.search.includes('state=')
                      };
                      console.error('Datadog error logged - error during initAuth', _context2.t0, _context);
                      datadogRum.addError(new Error('Error during initAuth:', {
                        cause: _context2.t0
                      }), _context);
                    case 27:
                      _context2.prev = 27;
                      _context2.next = 30;
                      return _this.refreshUser();
                    case 30:
                      _this.clearStorageForInactiveSession();
                      _context2.next = 33;
                      return _this.checkSSOSession();
                    case 33:
                      return _context2.finish(27);
                    case 34:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee, null, [[15, 22, 27, 34]]);
              }))();
            },
            /**
             * Redirects the user to the Auth0 login page.
             * @async
             * @param {CustomAuth0Settings} customAuth0Settings - Custom brand settings for Auth0 login page
             * @returns {Promise<void>}
             */
            login: function login(customAuth0Settings) {
              var _this2 = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this2$auth0Client;
                return regeneratorRuntime.wrap(function _callee2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return (_this2$auth0Client = _this2.auth0Client) === null || _this2$auth0Client === void 0 ? void 0 : _this2$auth0Client.loginWithRedirect({
                        authorizationParams: _objectSpread({}, customAuth0Settings)
                      });
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee2);
              }))();
            },
            /**
             * Logs the user out and clears cookies.
             * @async
             * @returns {Promise<void>}
             */
            logout: function logout() {
              var _this3 = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this3$auth0Client;
                return regeneratorRuntime.wrap(function _callee3$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if ($config['NUXT_ENV_IS_BOOKING_PORTAL'] || isDedicatedFlow(route)) {
                        app['$cookies'].removeAll({
                          path: '/',
                          domain: getCookieDomain()
                        });
                      }
                      _context4.next = 3;
                      return (_this3$auth0Client = _this3.auth0Client) === null || _this3$auth0Client === void 0 ? void 0 : _this3$auth0Client.logout({
                        logoutParams: {
                          returnTo: _this3.returnUrl // Redirect URL after logout
                        }
                      });
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee3);
              }))();
            },
            /**
             * Refreshes user information and authentication state.
             * @async
             * @returns {Promise<void>}
             */
            refreshUser: function refreshUser() {
              var _this4 = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _this4$auth0Client, _this4$auth0Client2;
                var user, isAuthenticated;
                return regeneratorRuntime.wrap(function _callee4$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return (_this4$auth0Client = _this4.auth0Client) === null || _this4$auth0Client === void 0 ? void 0 : _this4$auth0Client.getUser();
                    case 2:
                      user = _context5.sent;
                      _context5.next = 5;
                      return (_this4$auth0Client2 = _this4.auth0Client) === null || _this4$auth0Client2 === void 0 ? void 0 : _this4$auth0Client2.isAuthenticated();
                    case 5:
                      isAuthenticated = _context5.sent;
                      _this4.user = user || null;
                      _this4.isAuthenticated = isAuthenticated || false;
                    case 8:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee4);
              }))();
            },
            /**
             * Clears local storage if the Auth0 session is inactive.
             * Needed when logging out on one subdomain and returning to another.
             */
            clearStorageForInactiveSession: function clearStorageForInactiveSession() {
              var isAuth0SessionActive = app.$cookies.get("".concat(COOKIES_KEY_PREFIX, ".").concat(this.clientId, ".is.authenticated"));

              // Check if there's a mismatch between Auth0's session (cookie-based) and app's state
              // - `!isAuth0Authenticated`: Auth0 cookie is missing, meaning Auth0 considers the user logged out.
              // - `this.isAuthenticated`: App's state (@auth0/auth0-spa-js plugin) still thinks the user is logged in.
              if (!isAuth0SessionActive && this.isAuthenticated) {
                // Clear local storage to ensure full logout all subdomains
                localStorage.removeItem("".concat(CACHE_KEY_PREFIX, "::").concat(this.clientId, "::").concat(this.audience, "::openid profile email"));
                localStorage.removeItem("".concat(CACHE_KEY_PREFIX, "::").concat(this.clientId, "::").concat(CACHE_KEY_USER_SUFFIX));
                if (!$config['NUXT_ENV_IS_BOOKING_PORTAL']) window.location.href = '/';
              }
            },
            /**
             * Checks the SSO session (dedicated flows e.g booking portal) and restores the user state if active.
             * @async
             * @returns {Promise<void>}
             */
            checkSSOSession: function checkSSOSession() {
              var _this5 = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var token, expiration;
                return regeneratorRuntime.wrap(function _callee5$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      token = app['$cookies'].get("".concat(COOKIES_KEY_PREFIX, ".").concat(_this5.clientId, ".token"));
                      expiration = app['$cookies'].get("".concat(COOKIES_KEY_PREFIX, ".").concat(_this5.clientId, ".tokenExpiration"));
                      if (!token) {
                        _context6.next = 6;
                        break;
                      }
                      _context6.next = 5;
                      return _this5.fetchUser(token);
                    case 5:
                      _this5.setUserToken(token, expiration);
                    case 6:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee5);
              }))();
            },
            /**
             * Fetches user details from Auth0's userinfo endpoint. Needed for SSO sessions
             * (dedicated flows e.g booking portal) to fetch user data manually
             *
             * @async
             * @param {string} token - The Auth0 access token.
             * @returns {Promise<void>}
             */
            fetchUser: function fetchUser(token) {
              var _this6 = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var response, user, userStorageKey, tokenNoBearer, userData, context;
                return regeneratorRuntime.wrap(function _callee6$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.prev = 0;
                      _context7.next = 3;
                      return axios.get("https://".concat(_this6.domain, "/userinfo"), {
                        headers: {
                          Authorization: token
                        }
                      });
                    case 3:
                      response = _context7.sent;
                      user = response.data;
                      userStorageKey = "".concat(CACHE_KEY_PREFIX, "::").concat(_this6.clientId, "::").concat(CACHE_KEY_USER_SUFFIX);
                      tokenNoBearer = token.replace('Bearer ', '');
                      userData = {
                        decodedToken: {
                          user: user
                        },
                        id_token: tokenNoBearer
                      };
                      localStorage.setItem(userStorageKey, JSON.stringify(userData));
                      _context7.next = 11;
                      return _this6.refreshUser();
                    case 11:
                      _context7.next = 18;
                      break;
                    case 13:
                      _context7.prev = 13;
                      _context7.t0 = _context7["catch"](0);
                      context = {
                        file: 'white-label-plugin > auth.ts > fetchUser()',
                        domain: _this6.domain || '',
                        token: app['$cookies'].get("".concat(COOKIES_KEY_PREFIX, ".").concat(_this6.clientId, ".token")) || ''
                      };
                      console.error('Datadog error logged - fetchUser', context);
                      datadogRum.addError(new Error('Auth fetchUser:', {
                        cause: _context7.t0
                      }), context);
                    case 18:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee6, null, [[0, 13]]);
              }))();
            },
            /**
             * Sets tokens in localStorage and cookies for SSO session management
             * (dedicated flows e.g booking portal).
             * @param {string} token - The Auth0 access token.
             * @param {number} tokenExpiration - The token expiration.
             */
            setUserToken: function setUserToken(token, tokenExpiration) {
              var tokenStorageKey = "".concat(CACHE_KEY_PREFIX, "::").concat(this.clientId, "::").concat(this.audience, "::openid profile email");
              var tokenNoBearer = token.replace('Bearer ', '');
              var tokenData = {
                body: {
                  access_token: tokenNoBearer,
                  audience: this.audience,
                  client_id: this.clientId,
                  oauthTokenScope: "openid profile email",
                  scope: "openid profile email",
                  token_type: "Bearer"
                },
                expiresAt: tokenExpiration
              };
              var cookieDomain = getCookieDomain();
              app['$cookies'].set("_legacy_".concat(COOKIES_KEY_PREFIX, ".").concat(this.clientId, ".is.authenticated"), true, {
                domain: cookieDomain,
                secure: true,
                maxAge: tokenExpiration - new Date().getTime() / 1000,
                path: '/'
              });
              app['$cookies'].set("".concat(COOKIES_KEY_PREFIX, ".").concat(this.clientId, ".is.authenticated"), true, {
                domain: cookieDomain,
                sameSite: 'None',
                secure: true,
                maxAge: tokenExpiration - new Date().getTime() / 1000,
                path: '/'
              });
              app['$cookies'].set("".concat(COOKIES_KEY_PREFIX, ".").concat(this.clientId, ".token"), token, {
                domain: cookieDomain,
                path: '/'
              });
              app['$cookies'].set("".concat(COOKIES_KEY_PREFIX, ".").concat(this.clientId, ".tokenExpiration"), tokenExpiration, {
                domain: cookieDomain,
                path: '/'
              });
              app['$cookies'].set("".concat(COOKIES_KEY_PREFIX, ".").concat(this.clientId, ".returnUrl"), this.returnUrl, {
                domain: cookieDomain,
                path: '/'
              });
              localStorage.setItem(tokenStorageKey, JSON.stringify(tokenData));
            },
            /**
             * Retrieves a token.
             * @async
             * @returns {Promise<string|null>} The token prefixed with "Bearer" or null if no token is available.
             */
            getToken: function getToken() {
              var _this7 = this;
              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var _this7$auth0Client;
                var tokenWithBearer, token;
                return regeneratorRuntime.wrap(function _callee7$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      tokenWithBearer = null;
                      _context8.next = 3;
                      return (_this7$auth0Client = _this7.auth0Client) === null || _this7$auth0Client === void 0 ? void 0 : _this7$auth0Client.getTokenSilently();
                    case 3:
                      token = _context8.sent;
                      if (token) {
                        tokenWithBearer = "Bearer ".concat(token);
                      }
                      return _context8.abrupt("return", tokenWithBearer);
                    case 6:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee7);
              }))();
            }
          };
          _context9.next = 4;
          return auth.initAuth();
        case 4:
          inject('auth', auth);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee8);
  }));
  return function auth(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default auth;